import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export const FinalCTA = ({ onOpenLeadModal }) => {
  const { t } = useTranslation();

  return (
    <section
      className="py-32 bg-gradient-to-br from-[hsl(215,75%,16%)] to-[hsl(224,64%,33%)] text-white relative overflow-hidden"
      data-testid="final-cta-section"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2
          className="text-4xl sm:text-5xl lg:text-6xl font-black mb-6 tracking-tight"
          style={{ fontFamily: 'Outfit' }}
        >
          {t('finalCta.title')}
        </h2>
        <p className="text-xl sm:text-2xl text-white/95 mb-12 leading-relaxed max-w-2xl mx-auto font-medium">
          {t('finalCta.subtitle')}
        </p>
        <Button
          onClick={onOpenLeadModal}
          className="btn-premium btn-premium-secondary text-lg px-12 py-6"
          data-testid="final-cta-button"
        >
          {t('finalCta.cta')}
        </Button>

        {/* Contact Info */}
        <div className="mt-12 pt-12 border-t border-white/20">
          <p className="text-white/80 mb-4 font-semibold">{t('finalCta.orCall')}</p>
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-8">
            <a
              href="tel:+14074510902"
              className="text-2xl font-bold hover:text-white/80 transition-colors duration-200 flex items-center"
              data-testid="final-cta-phone-1"
            >
              <svg className="w-6 h-6 mr-2" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
              </svg>
              +1 (407) 451-0902
            </a>
            <a
              href="tel:+14074961867"
              className="text-2xl font-bold hover:text-white/80 transition-colors duration-200 flex items-center"
              data-testid="final-cta-phone-2"
            >
              <svg className="w-6 h-6 mr-2" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
              </svg>
              +1 (407) 496-1867
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};